import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const domainApi = createApi({
  reducerPath: "domainApis",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["domains", "register", "user-domain", "domain-result"],
  endpoints: (builder) => ({
    getDomainsList: builder.query({
      query: () => "/domain",
      providesTags: ["domains"],
    }),
    checkDomainAvailability: builder.query({
      query: ({ domainName }) => `domain/availability/${domainName}`,
      providesTags: ["domains"],
    }),
    getDomainResource: builder.query({
      query: ({ resourse }) => `domain/resource/${resourse}`,
      providesTags: ["domain-result"],
    }),
    registerDomain: builder.mutation({
      query: (body) => ({
        url: "/domain/register",
        method: "POST",
        body,
      }),
      invalidatesTags: ["register"],
    }),
  }),
});

export const {
  useLazyCheckDomainAvailabilityQuery,
  useLazyGetDomainResourceQuery,
  useGetDomainsListQuery,
  useRegisterDomainMutation,
} = domainApi;
